import { SparePart, SubPart } from '../types/storage.js';
import { willekeurigElement } from '../hulp.js';
export const totalFromEachSparePart = 3;
export const storageSlots = 16;
/**
 * Niet in het origineel: of deze doos er al is. Een gekochte doos is onderweg tot het begin van
 * de volgende week. Een doos zonder het kenmerk `onderweg` (ook uit oudere spellen) is er.
 */
export const isAangekomen = (doos) => doos.onderweg !== true;
/**
 * Niet in het origineel: of in dit vak een open doos staat die er al is. Alleen zo'n doos telt
 * voor de taken van deze week.
 */
export const ligtOpen = (doos) => !!doos && doos.open && isAangekomen(doos);
/**
 * Niet in het origineel: hoeveel van de `storageSlots` vakken nog leeg zijn. Een doos die
 * onderweg is, neemt al een vak in. Nooit minder dan nul, ook niet in een ouder spel waarin
 * er meer dozen dan vakken waren.
 */
export const vrijeVakken = (game) => Math.max(0, storageSlots - game.storageContent.filter((vak) => !!vak).length);
/**
 * Niet in het origineel: hoeveel dozen weg kunnen om plek te maken voor een inkoop. Elke doos
 * die er al is, open of dicht; een doos die nog onderweg is, niet.
 */
export const weggooibareDozen = (game) => game.storageContent.filter((vak) => !!vak && isAangekomen(vak)).length;
const createStorage = () => {
    return {
        icons: {},
        spareparts: Object.values(SparePart),
        subparts: Object.values(SubPart),
        composition: {
            [SparePart.aandrijving]: [SubPart.aandrijfsnaar, SubPart.snaarwiel, SubPart.tandwiel],
            [SparePart.deegwals]: [SubPart.aandrijfsnaar, SubPart.kogellager, SubPart.tandwiel],
            [SparePart.doorvoerband]: [SubPart.snaarwiel, SubPart.nonStickBand, SubPart.kogellager],
            [SparePart.eMotor]: [SubPart.rotor, SubPart.kogellager, SubPart.kabel],
            [SparePart.flexpicker]: [SubPart.armstaaf, SubPart.scharnier, SubPart.draaias],
            [SparePart.infraroodCamera]: [SubPart.lens, SubPart.cameraChip, SubPart.stekker],
            [SparePart.luchtfilters]: [SubPart.pakking, SubPart.koolstofLaag, SubPart.frame],
            [SparePart.meelDoseerder]: [SubPart.deksel, SubPart.draaias, SubPart.trechter],
            [SparePart.thermostaat]: [SubPart.draaiweerstand, SubPart.warmteSensor, SubPart.kabel],
            [SparePart.vacuumGripper]: [SubPart.zuignap, SubPart.rubberRing, SubPart.luchtslang],
            [SparePart.verwarmingselement]: [
                SubPart.warmtewisselaar,
                SubPart.rubberRing,
                SubPart.pakking,
            ],
            [SparePart.watertoevoerklep]: [SubPart.scharnier, SubPart.rubberRing, SubPart.deksel],
        },
    };
};
/**
 * Het ene document uit de collectie `staticGameData.storage`. Schermen die
 * `StorageCollection.findOne()` lazen, gebruiken dit. `icons` was ook in het origineel leeg.
 */
export const MAGAZIJN = createStorage();
/**
 * De inhoud van het magazijn bij een nieuw spel: drie vaste onderdelen, aangevuld tot acht
 * met willekeurige (hooguit drie van dezelfde soort). Vak 3 gaat daarna ook open.
 */
export const storageAtStart = (ctx) => {
    const spareParts = MAGAZIJN.spareparts;
    const parts = [
        { part: SparePart.infraroodCamera, open: true },
        { part: SparePart.eMotor, open: true },
        { part: SparePart.eMotor, open: true },
    ];
    while (parts.length < 8) {
        const random = {
            part: willekeurigElement(spareParts, ctx.random),
            open: false,
        };
        if (parts.filter(({ part }) => part === random.part).length < 3)
            parts.push(random);
    }
    // Bestaat altijd: de lus hierboven stopt pas bij acht onderdelen.
    const vierde = parts[3];
    if (vierde)
        vierde.open = true;
    return parts;
};
